// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */

.header {
  position: relative;
  display: block;
  max-width: 90%;
  padding: 20px 10px;
  margin: -10px auto;
  z-index: 10001;
}

.header ul {
  margin: 0;
  padding: 10px;
  list-style: none;
  overflow: hidden;
}

.grey-color {
  color: #868e96;
}

.header li a {
  display: block;
  padding: 10px 20px;
  /* color: black; */
  text-decoration: none;
}

.header .logo {
  display: block;
  float: left;
  font-size: 1.5em;
  text-decoration: none;
  margin-top: -12px;
  line-height: normal;
}

.header .logo-name {
  font-family: "Google Sans Regular";
  font-weight: bold;
  padding: 0 10px;
  letter-spacing: 3px;
  /* color: #55198b; */
}

/* menu */

.menu {
  font-family: "Google Sans Regular";
}

.header .menu {
  margin-top: 10px;
  clear: both;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

/* menu icon */

.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 28px 20px;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.header .menu-icon .navicon {
  background: #fb1056;
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 18px;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #fb1056;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */

.header .menu-btn {
  display: none;
}

.header .menu-btn:checked~.menu {
  max-height: 370px;
}

.header .menu-btn:checked~.menu-icon .navicon {
  background: transparent;
}

.header .menu-btn:checked~.menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked~.menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked~.menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked~.menu-icon:not(.steps) .navicon:after {
  top: 0;
}

.homei {
  margin: 2px 5px 20px 10px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
}

.homei:hover {
  box-shadow: 0 2px 10px #2ab0ee;
  background-color: #2ab0ee;
  color: #ffffff !important;
}

.ec {
  margin: 2px 5px 20px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
}

.ec:hover {
  box-shadow: 0 2px 10px #eb6559;
  background-color: #eb6559;
  color: #ffffff !important;
}

.xp {
  margin: 2px 5px 20px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
}

.xp:hover {
  box-shadow: 0 2px 10px #f7b908;
  background-color: #f7b908;
  color: #ffffff !important;
}

.projects {
  margin: 2px 5px 20px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
}

.projects:hover {
  box-shadow: 0 2px 10px #e44160;
  background-color: #e44160;
  color: #ffffff !important;
}

.cr {
  margin: 2px 5px 20px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
}

.cr:hover {
  box-shadow: 0 1px 10px #47a148;
  background-color: #47a148;
  color: #ffffff !important;
}

/* 48em = 768px */

/* Interests menu item */
.interests {
  margin: 2px 5px 20px;
  transition: all 0.2s ease-in-out;
  color: #ffffff;
  position: relative;
  padding: 10px 20px;
}

.interests:hover {
  box-shadow: 0 2px 10px #9b59b6;
  background-color: #9b59b6;
  color: #ffffff !important;
}

/* Dropdown styles */
.dropdown-content {
  position: fixed;
  background-color: rgba(30, 30, 30, 0.95);
  backdrop-filter: blur(10px);
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  border-radius: 8px;
  margin-top: 0;
  padding: 8px 0;
  border: 1px solid rgba(255, 255, 255, 0.1);

  /* Animation properties */
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  pointer-events: none;
}

/* Open state */
.dropdown-content.dropdown-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
}

.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
  transition: all 0.2s ease;
  border-radius: 4px;
  margin: 2px 8px;
}

.dropdown-content a:hover {
  background-color: rgba(155, 89, 182, 0.3);
  transform: translateX(5px);
}

@media (min-width: 48em) {
  .header li {
    float: left;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header .menu {
    max-height: none;
  }

  .header .menu-icon {
    display: none;
  }
}

@media (max-width: 768px) {
  .header .logo {
    display: block;
    float: left;
    font-size: 1.25em;
    text-decoration: none;
    margin-top: 15px;
    line-height: normal;
  }

  .header {
    padding-top: 10px;
    text-align: center;
  }
}

@media (max-width: 960px) and (min-width: 768px) {
  .header {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,SAAS;;AAET;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oCAAoC;AACtC;;AAEA,cAAc;;AAEd;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA,aAAa;;AAEb;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,iBAAiB;;AAEjB,wBAAwB;AACxB;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,wCAAwC;EACxC,2BAA2B;EAC3B,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,0CAA0C;;EAE1C,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,mEAAmE;EACnE,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* header */\n\n.header {\n  position: relative;\n  display: block;\n  max-width: 90%;\n  padding: 20px 10px;\n  margin: -10px auto;\n  z-index: 10001;\n}\n\n.header ul {\n  margin: 0;\n  padding: 10px;\n  list-style: none;\n  overflow: hidden;\n}\n\n.grey-color {\n  color: #868e96;\n}\n\n.header li a {\n  display: block;\n  padding: 10px 20px;\n  /* color: black; */\n  text-decoration: none;\n}\n\n.header .logo {\n  display: block;\n  float: left;\n  font-size: 1.5em;\n  text-decoration: none;\n  margin-top: -12px;\n  line-height: normal;\n}\n\n.header .logo-name {\n  font-family: \"Google Sans Regular\";\n  font-weight: bold;\n  padding: 0 10px;\n  letter-spacing: 3px;\n  /* color: #55198b; */\n}\n\n/* menu */\n\n.menu {\n  font-family: \"Google Sans Regular\";\n}\n\n.header .menu {\n  margin-top: 10px;\n  clear: both;\n  max-height: 0;\n  transition: max-height 0.2s ease-out;\n}\n\n/* menu icon */\n\n.header .menu-icon {\n  cursor: pointer;\n  display: inline-block;\n  float: right;\n  padding: 28px 20px;\n  position: relative;\n  user-select: none;\n}\n\n.header .menu-icon .navicon {\n  background: #fb1056;\n  display: block;\n  height: 2px;\n  position: relative;\n  transition: background 0.2s ease-out;\n  width: 18px;\n}\n\n.header .menu-icon .navicon:before,\n.header .menu-icon .navicon:after {\n  background: #fb1056;\n  content: \"\";\n  display: block;\n  height: 100%;\n  position: absolute;\n  transition: all 0.2s ease-out;\n  width: 100%;\n}\n\n.header .menu-icon .navicon:before {\n  top: 5px;\n}\n\n.header .menu-icon .navicon:after {\n  top: -5px;\n}\n\n/* menu btn */\n\n.header .menu-btn {\n  display: none;\n}\n\n.header .menu-btn:checked~.menu {\n  max-height: 370px;\n}\n\n.header .menu-btn:checked~.menu-icon .navicon {\n  background: transparent;\n}\n\n.header .menu-btn:checked~.menu-icon .navicon:before {\n  transform: rotate(-45deg);\n}\n\n.header .menu-btn:checked~.menu-icon .navicon:after {\n  transform: rotate(45deg);\n}\n\n.header .menu-btn:checked~.menu-icon:not(.steps) .navicon:before,\n.header .menu-btn:checked~.menu-icon:not(.steps) .navicon:after {\n  top: 0;\n}\n\n.homei {\n  margin: 2px 5px 20px 10px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n}\n\n.homei:hover {\n  box-shadow: 0 2px 10px #2ab0ee;\n  background-color: #2ab0ee;\n  color: #ffffff !important;\n}\n\n.ec {\n  margin: 2px 5px 20px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n}\n\n.ec:hover {\n  box-shadow: 0 2px 10px #eb6559;\n  background-color: #eb6559;\n  color: #ffffff !important;\n}\n\n.xp {\n  margin: 2px 5px 20px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n}\n\n.xp:hover {\n  box-shadow: 0 2px 10px #f7b908;\n  background-color: #f7b908;\n  color: #ffffff !important;\n}\n\n.projects {\n  margin: 2px 5px 20px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n}\n\n.projects:hover {\n  box-shadow: 0 2px 10px #e44160;\n  background-color: #e44160;\n  color: #ffffff !important;\n}\n\n.cr {\n  margin: 2px 5px 20px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n}\n\n.cr:hover {\n  box-shadow: 0 1px 10px #47a148;\n  background-color: #47a148;\n  color: #ffffff !important;\n}\n\n/* 48em = 768px */\n\n/* Interests menu item */\n.interests {\n  margin: 2px 5px 20px;\n  transition: all 0.2s ease-in-out;\n  color: #ffffff;\n  position: relative;\n  padding: 10px 20px;\n}\n\n.interests:hover {\n  box-shadow: 0 2px 10px #9b59b6;\n  background-color: #9b59b6;\n  color: #ffffff !important;\n}\n\n/* Dropdown styles */\n.dropdown-content {\n  position: fixed;\n  background-color: rgba(30, 30, 30, 0.95);\n  backdrop-filter: blur(10px);\n  min-width: 200px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3);\n  z-index: 10000;\n  border-radius: 8px;\n  margin-top: 0;\n  padding: 8px 0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n\n  /* Animation properties */\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;\n  pointer-events: none;\n}\n\n/* Open state */\n.dropdown-content.dropdown-open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n.dropdown-content a {\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n  text-align: left;\n  transition: all 0.2s ease;\n  border-radius: 4px;\n  margin: 2px 8px;\n}\n\n.dropdown-content a:hover {\n  background-color: rgba(155, 89, 182, 0.3);\n  transform: translateX(5px);\n}\n\n@media (min-width: 48em) {\n  .header li {\n    float: left;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .header .menu {\n    max-height: none;\n  }\n\n  .header .menu-icon {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .header .logo {\n    display: block;\n    float: left;\n    font-size: 1.25em;\n    text-decoration: none;\n    margin-top: 15px;\n    line-height: normal;\n  }\n\n  .header {\n    padding-top: 10px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 960px) and (min-width: 768px) {\n  .header {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
